

import "./colors.st.css.js";
import { classesRuntime, statesRuntime } from "./../../stylable-esm-runtime.js";



var _namespace_ = "wds_1_119_0_defaultscrollbar";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_119_0_defaultscrollbar__root","defaultScrollBar":"wds_1_119_0_defaultscrollbar__defaultScrollBar"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {"wds-scrollbar-fill":"--wds-scrollbar-fill","wds-scrollbar-fill-hover":"--wds-scrollbar-fill-hover","wds-scrollbar-fill-active":"--wds-scrollbar-fill-active","wds-border-radius-full":"--wds-border-radius-full"}; 




